import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { updateEmployerUrlRoute } from '../api/constant';
import { adminEmployersList, adminEnterprisesList } from '../constants';

type useUpdateEmployerUrlProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUpdateEmployerUrl = ({
  setErrorText = () => {},
}: useUpdateEmployerUrlProps) => {
  const client = useQueryClient();

  const { mutate: updateUrl, isLoading: isUpdateUrlLoading } = useMutation({
    mutationFn: (variables: {
      company_id: number | string;
      url: string;
      is_enterprise: boolean;
    }) =>
      axiosInstance
        .post(updateEmployerUrlRoute, variables, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        client.invalidateQueries(adminEmployersList);
        client.invalidateQueries(adminEnterprisesList);
        setErrorText('');
      } else {
        setErrorText(data.message || errorMessage);
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    updateUrl,
    isUpdateUrlLoading,
  };
};
